import { Colors } from '~/themes/colors';
import { IIconProps } from './Types';

export const ArrowRightCircleOutlineIcon = ({
  color = Colors.secondary_500,
  size = 24,
}: IIconProps) => (
  <svg fill="none" height={size} viewBox="0 0 25 24" width={size}>
    <path
      d="M13.0998 9L16.1227 12M16.1227 12L13.0998 15M16.1227 12L8.06161 12M21.1608 12C21.1608 16.9706 17.1006 21 12.0921 21C7.08363 21 3.02344 16.9706 3.02344 12C3.02344 7.02944 7.08363 3 12.0921 3C17.1006 3 21.1608 7.02944 21.1608 12Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
